import React, { useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { MenuItemType, OffertaType } from '@next-nx/utils/types'
import { Button, WContainer } from '@next-nx/shared-ui/atoms'
import { OffertaCard } from '@next-nx/shared-ui/molecules'
import styles from './ProdottiCorrelati.module.sass'
import { useComparatore, useTealium } from '@next-nx/hooks'
import { getCategoriaUrlParam, getTimestamp } from '@next-nx/utils'

interface Props {
  item: MenuItemType
  offerte: OffertaType[]
  codiceCategoriaPrimaria?: string | undefined
  className?: string
}

const ProdottiCorrelati = (props: Props) => {
  const {
    item = undefined,
    offerte = [],
    codiceCategoriaPrimaria = undefined,
    className = '',
  } = props

  const { maxCompareItems, compareItems, setCompareItems, setLimitReached, firstTime } = useComparatore()
  const { linkDataLayer, getListingProdottiData } = useTealium()

  const handleTracking = (interazione: string = '') => {
    let dlObj = {}
    const action_timestamp = getTimestamp()

    switch (interazione) {
      case 'navigazione':
        dlObj = {
          virtual: 'action',
          action_name: 'navigazione',
          action_tech: 'click',
          action_type: 'vai_al_comparatore',
          action_timestamp,
          action_effect: 'interazione_componente_comparatore',
        }
        break
      case 'items_view':
        dlObj = {
          virtual: "action",
          action_name: "items_view", 
          action_tech: "view",
          action_type: "carosello",
          action_timestamp,
          action_effect: "visualizzazione_prodotti",
          view_items: getListingProdottiData(offerte, codiceCategoriaPrimaria, "altre_proposte"),
        }
        break
      default:
        dlObj
        break
    }

    linkDataLayer(dlObj)
  }

  useEffect(() => {
    handleTracking("items_view")
  }, [])

  return offerte.length ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <div className={styles.layout}>
          {!!item && (
            <div className={styles.content}>
              {!!item.name && <p className={styles.title}>{item.name}</p>}
              {!!item.description && (
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              )}
              {!!item.ctaLabel && !!item.url && (
                <div className={styles.ctaBox}>
                  <Button label={item.ctaLabel} href={item.url + getCategoriaUrlParam(codiceCategoriaPrimaria)} onClick={() => handleTracking("navigazione")} />
                </div>
              )}
            </div>
          )}
          <div className={styles.list}>
            <Swiper
              slidesPerView={1.2}
              spaceBetween={30}
              breakpoints={{
                576: {
                  slidesPerView: 2.2,
                },
                768: {
                  slidesPerView: 3,
                },
              }}
            >
              {offerte.map((x) => (
                <SwiperSlide key={x.pk}>
                  <OffertaCard
                    offerta={x}
                    codiceCategoriaPrimaria={codiceCategoriaPrimaria}
                    comparable
                    compareActive={compareItems.filter((ci) => ci.pk === x.pk).length > 0}
                    sezione='carosello'
                    cta='icona_pdp_proposte'
                    onCompare={
                      compareItems.filter((ci) => ci.pk === x.pk).length > 0
                        ? () => setCompareItems(compareItems.filter((ci) => ci.pk !== x.pk))
                        : compareItems.length < maxCompareItems
                        ? () => setCompareItems(compareItems.concat([x]))
                        : () => setLimitReached(true)
                    }
                    showTooltip
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default ProdottiCorrelati
